<template>
  <canvas
    v-bind="{ width, height }"
    :class="{ screenShotCanvas: true, screenShot: isScreenCapEnabled, 'overlay-page': true }"
    @mousedown="mouseDown($event)"
  ></canvas>
</template>

<script>
import html2canvas from 'html2canvas';

export default {
  props: {
    target: {
      //  the dom element you want a screenshot of
    },
    active: {
      default: false
    },
    overlayAttributesSimple: {
      type: Object,
      default: () => ({
        style: null,
        width: null,
        height: null
      })
    }
  },
  data() {
    return {
      isScreenCapEnabled: true,
      isCleared: false,
      startDrag: {
        x: 0,
        y: 0
      },
      finalShape: {
        minY: 0,
        minX: 0,
        width: 0,
        height: 0
      }
    };
  },
  computed: {
    width() {
      return this.target.offsetWidth;
    },
    height() {
      return this.target.offsetHeight;
    }
  },
  created() {
    //  get a capture of the whole page
    this.createCanvas();
  },
  destroyed() {
    document.addEventListener('mouseup', this.mouseUp);
    document.addEventListener('mousemove', this.mouseMove);
  },
  methods: {
    createCanvas() {
      console.log('create canvas!');
      html2canvas(this.target).then(canvas => {
        this.pageCanvas = canvas;
      });
    },
    clearScreenShotCanvas() {
      const screenShotCanvas = this.$el;
      const ctx = screenShotCanvas.getContext('2d');
      ctx.clearRect(0, 0, screenShotCanvas.width, screenShotCanvas.height);
      ctx.fillStyle = 'rgba(0, 0, 0, 0.3)';
      ctx.rect(0, 0, screenShotCanvas.width, screenShotCanvas.height);
      ctx.fill();
      this.isCleared = true;
      this.$emit('selection', {
        imageUrl: false,
        showBtn: false,
        position: {}
      });
    },
    drawSelection(input) {
      const { minX, minY, width, height } = input;
      const screenShotCanvas = this.$el;
      const ctx = screenShotCanvas.getContext('2d');
      this.clearScreenShotCanvas();
      ctx.strokeStyle = 'lightblue';
      ctx.strokeWidth = 3;
      ctx.clearRect(minX, minY, width, height);
      ctx.strokeRect(minX, minY, width, height);
      this.isCleared = false;
    },
    mouseDown(event) {
      this.clearScreenShotCanvas();
      this.startDrag = { x: event.offsetX, y: event.offsetY };
      document.addEventListener('mouseup', this.mouseUp);
      document.addEventListener('mousemove', this.mouseMove);
    },
    mouseUp() {
      document.removeEventListener('mouseup', this.mouseUp);
      document.removeEventListener('mousemove', this.mouseMove);
      const isAreaSelected = this.finalShape.width > 5 && this.finalShape.height > 5;
      if (!isAreaSelected) {
        this.clearScreenShotCanvas();
        this.finalShape = { minY: 0, minX: 0, width: 0, height: 0 };
      } else {
        //  CAPTURE
        this.captureScreenShot();
      }
      this.startDrag = { x: 0, y: 0 };
    },
    mouseMove(event) {
      const down = this.startDrag;
      if ('x' in down && down.page === this.pageNumber) {
        let currentDrag = { x: event.offsetX, y: event.offsetY };
        const finalShape = {};
        finalShape.minY = Math.min(currentDrag.y, down.y);
        finalShape.minX = Math.min(currentDrag.x, down.x);
        finalShape.width = Math.abs(currentDrag.x - down.x);
        finalShape.height = Math.abs(currentDrag.y - down.y);
        this.finalShape = finalShape;
      }
    },
    captureScreenShot() {
      // console.log('dimensions', dimensions);
      const { minX, minY, width, height } = this.finalShape;
      this.$emit('selection', {
        showBtn: true,
        imageUrl: false,
        position: this.finalShape
      });
      this.$nextTick(() => {
        const canvas = this.pageCanvas;
        let croppedCanvas = document.createElement('canvas');
        let croppedCanvasContext = croppedCanvas.getContext('2d');
        croppedCanvas.width = width;
        croppedCanvas.height = height;
        croppedCanvasContext.drawImage(canvas, minX, minY, width, height, 0, 0, width, height);
        const imageUrl = croppedCanvas.toDataURL('image/jpg');
        this.$emit('imageReady', imageUrl);
        // html2canvas(this.target, { x: minX, y: minY, width, height })
        //   .then(canvas => {
        //     // let croppedCanvas = document.createElement('canvas'),
        //     // croppedCanvasContext = croppedCanvas.getContext('2d');

        //     // croppedCanvas.width  = width;
        //     // croppedCanvas.height = height;

        //     // croppedCanvasContext.drawImage(canvas, minX, minY, width, height, 0, 0, width, height);
        //     const imageUrl = canvas.toDataURL('image/png');
        //     console.log(imageUrl);
        //     this.$emit('imageReady', imageUrl);
        //     return;
        //   })
        //   .catch(e => {
        //     console.log(e);
        //     return;
        //   });
      });

      // const bufferCanvas1 = document.createElement('canvas');
      // const textLayer = this.$refs['textLayer'];
      // // console.log('this.$refs', this.$refs);
      // // console.log('textLayer', textLayer);
      // const originalCanvas = target;
      // console.log('render', originalCanvas.width, originalCanvas.height);
      // console.log('textLayer', textLayer.offsetWidth, textLayer.offsetHeight);
      // bufferCanvas1.width = textLayer.offsetWidth;
      // bufferCanvas1.height = textLayer.offsetHeight;
      // bufferCanvas1
      //   .getContext('2d')
      //   .drawImage(
      //     originalCanvas,
      //     0,
      //     0,
      //     originalCanvas.width,
      //     originalCanvas.height,
      //     0,
      //     0,
      //     bufferCanvas1.width,
      //     bufferCanvas1.height
      //   );

      // // console.log('bufferCanvas1 has been drawn', bufferCanvas1);
      // const bufferCanvas2 = document.createElement('canvas');
      // bufferCanvas2.width = width;
      // bufferCanvas2.height = height;
      // bufferCanvas2
      //   .getContext('2d')
      //   .drawImage(bufferCanvas1, minX, minY, width, height, 0, 0, width, height);
      // const savedSelection = {};
      // savedSelection.url = bufferCanvas2.toDataURL('image/png');
      // savedSelection.pages = [];
      // savedSelection.positions = [];

      // savedSelection.pages.push(this.pageNumber);
      // const positions = {
      //   x: minX / bufferCanvas1.width,
      //   y: minY / bufferCanvas1.height,
      //   width: width / bufferCanvas1.width,
      //   height: height / bufferCanvas1.height,
      //   page: this.pageNumber
      // };
      // savedSelection.positions.push(positions);
      // console.log('savedSelection', savedSelection);
      // this.setCaptureCurrent(false);
      // this.setCapturedImage(savedSelection);
    }
  },
  watch: {
    finalShape(val) {
      this.drawSelection(val);
    },
    overlayAttributesSimple() {
      this.$nextTick(() => {
        this.clearScreenShotCanvas();
      });
    },
    active: function(n, o) {
      if (n) {
        if (this.pageCanvas.width != this.target.offsetWidth) {
          console.log(this.pageCanvas, this.target, this.width);
          //  page resized, get new canvas
          console.log('page resized');
          this.createCanvas();
        }
      }
      if (o) {
        this.clearScreenShotCanvas();
      }
    }
  },
};
</script>

<style>
.screenShotCanvas {
  opacity: 0;
  position: absolute;
  left: 0;
}
.screenShotCanvas:hover {
  cursor: crosshair;
}

.screenShotCanvas.screenShot {
  opacity: 1;
}
</style>
